import config from './production'

const conf = {
    ...config,
    env: "preproduction",
};

export default conf;